export default "__VITE_ASSET__DtoCuVnA__"